<div class="main-container py-4">
	<p-card class="success-card px-4">
		<span class="header mb-4">Success!</span>
		<span class="icon mb-4"><i class="pi pi-check"></i></span>
		<p class="font-weight-bold">Success! You now have now joined our Football Ticketing Service.</p>

		<p>We've sent you a confirmation email containing your account details. Please follow the link and set your password. These can be changed anytime, by visiting your My Account section.</p>
	</p-card>
</div>
